/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconYouhuiquan: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M772.262484 63.279871C738.129335 3.504194 657.063108-17.914356 597.330098 16.346791l-170.665742 98.132802-29.866505-17.066574c-63.999653-34.133148-140.799237-17.066574-174.932386 46.975746L72.53294 404.91002h895.995147l-196.265603-341.587483z m-150.399186 16.426577c21.333218-12.799931 72.788939-21.333218 85.58887 0l169.129751 274.771845-382.717927-197.929594 127.999306-76.842251zM170.665742 362.158252l106.666089-183.593673c17.066574-29.866505 55.466366-42.666436 85.332871-21.333217l393.34187 204.92689H170.665742zM597.330098 554.327877c25.599861 0 42.666436 9.386616 42.666435 34.986478s-17.066574 32.639823-42.666435 32.639823h-170.665742c-25.599861 0-42.666436-7.039962-42.666436-32.639823s17.066574-34.986477 42.666436-34.986478h170.665742z m0 166.527098c25.599861 0 42.666436 14.805253 42.666435 36.138471s-21.333218 35.157143-42.666435 35.157143h-170.665742c-25.599861 0-42.666436-13.781259-42.666436-35.157143 0-21.333218 21.333218-36.138471 42.666436-36.138471h170.665742z"
        fill={getIconColor(color, 0, '#444444')}
      />
      <path
        d="M904.528434 682.412517c0-46.933079 21.333218-89.684848 55.466366-115.284709V468.909673c0-34.133148-29.866505-64.04232-63.999653-64.042319H127.999307c-34.133148 0-63.999653 29.866505-63.999654 64.042319v85.418204c42.666436 25.599861 72.53294 72.53294 72.532941 128.08464a148.90586 148.90586 0 0 1-72.532941 128.084639v85.418204c0 34.133148 29.866505 63.999653 63.999654 63.999654h767.99584c34.133148 0 63.999653-29.866505 63.999653-63.999654v-98.218134c-34.133148-25.599861-55.466366-68.308963-55.466366-115.284709z m119.466019 213.502843C1023.994453 968.490967 968.528087 1024 895.995147 1024H127.999307c-72.53294 0-127.999307-55.509033-127.999307-128.08464v-128.127306c38.399792-8.533287 72.53294-42.666436 72.53294-85.375537 0-42.666436-29.866505-76.84225-72.53294-85.418204V468.909673C0 396.376733 55.466366 340.825034 127.999307 340.825034h767.99584c72.53294 0 127.999307 55.466366 127.999306 128.084639v132.351284c-34.133148 12.799931-55.466366 42.709102-55.466366 81.15156 0 38.399792 25.599861 68.308963 55.466366 81.108894v132.393949z"
        fill={getIconColor(color, 1, '#444444')}
      />
    </svg>
  );
};

IconYouhuiquan.defaultProps = {
  size: 18,
};

export default IconYouhuiquan;
